import React, { useState } from "react";
import Swal from "sweetalert2";

export const TransparentSection = (props) => {
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.first_name || !formData.last_name || !formData.email) {
      Swal.fire({
        icon: "warning",
        title: "Missing Fields",
        text: "Please fill in all required fields.",
      });
      return;
    }

    try {
      setLoading(true);

      const response = await fetch(
        "https://admin.businessunbuzzed.com/api/contact-us",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );

      if (response.status === 200 || response.status === 201) {
        Swal.fire({
          icon: "success",
          title: "Message Sent!",
          text: "Thank you for contacting us. We’ll get back to you shortly.",
          confirmButtonColor: "#3085d6",
        });

        setFormData({
          first_name: "",
          last_name: "",
          email: "",
          message: "",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Submission Failed",
          text: "Something went wrong. Please try again later.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Network Error",
        text: "Unable to send message. Please check your connection.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      id="transparent-section"
      style={{
        backgroundImage: "url('/img/contact-bg.jpeg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        color: "#fff",
      }}
    >
      {/* SPINNER OVERLAY */}
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 99999,
          }}
        >
          <div className="loader-spin"></div>
        </div>
      )}

      <div
        className="overlay"
        style={{ backgroundColor: "rgba(0,0,0,0.5)", padding: "60px 20px" }}
      >
        <div
          className="container-full"
          style={{ maxWidth: "900px", margin: "0 auto", textAlign: "center" }}
        >
          <h2 className="section-title">Stay Connected</h2>
          <p className="section-subtitle">
            Join our network and get the latest strategies to grow your business.
          </p>

          <form
            className="transparent-form"
            onSubmit={handleSubmit}
            style={{ marginTop: "30px" }}
          >
            <div
              className="row"
              style={{ display: "flex", gap: "10px", marginBottom: "15px" }}
            >
              <div className="col-md-6" style={{ flex: 1, paddingLeft: "7px" }}>
                <input
                  type="text"
                  name="first_name"
                  value={formData.first_name}
                  onChange={handleChange}
                  placeholder="First Name"
                  className="form-control"
                  style={{
                    width: "100%",
                    padding: "10px",
                    borderRadius: "5px",
                  }}
                  required
                />
              </div>
              <div className="col-md-6" style={{ flex: 1, paddingRight: "7px" }}>
                <input
                  type="text"
                  name="last_name"
                  value={formData.last_name}
                  onChange={handleChange}
                  placeholder="Last Name"
                  className="form-control"
                  style={{
                    width: "100%",
                    padding: "10px",
                    borderRadius: "5px",
                  }}
                  required
                />
              </div>
            </div>

            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Business Email"
              className="form-control"
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                marginBottom: "15px",
              }}
              required
            />

            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="Message (optional)"
              rows="4"
              className="form-control"
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                marginBottom: "15px",
              }}
            />

            <button
              type="submit"
              className="btn-custom"
              style={{
                padding: "12px 30px",
                borderRadius: "5px",
                backgroundColor: "#CC6600",
                color: "#fff",
                border: "none",
                cursor: "pointer",
                marginBottom: "30px",
                opacity: loading ? 0.7 : 1,
              }}
              disabled={loading}
            >
              {loading ? "Sending..." : "Join Now"}
            </button>

            {/* <div
              className="social"
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "20px",
                marginBottom: "15px",
              }}
            >
              <a
                href={props.data ? props.data.facebook : "/"}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#fff", fontSize: "24px" }}
              >
                <i className="fa fa-facebook"></i>
              </a>
              <a
                href={props.data ? props.data.twitter : "/"}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#fff", fontSize: "24px" }}
              >
                <i className="fa fa-twitter"></i>
              </a>
              <a
                href={props.data ? props.data.youtube : "/"}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#fff", fontSize: "24px" }}
              >
                <i className="fa fa-youtube"></i>
              </a>
            </div> */}
          </form>
        </div>
      </div>

      <div
        id="footer"
        style={{
          backgroundColor: "#111",
          padding: "30px 20px",
          textAlign: "center",
          marginTop: "61px",
        }}
      >
        <div className="container text-center">
          <p style={{ color: "#ccc", fontSize: "14px" }}>
            &copy; Copyright © 2025{" "}
            <a href="" rel="nofollow">
              Business Unbuzzed
            </a>{" "}
            | All Rights Reserved
          </p>
        </div>
      </div>
    </section>
  );
};
